module.exports = __webpack_public_path__ + "static/media/banner.3722361f.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageTextCheck/banner.png
// module id = 642
// module chunks = 0